import React from 'react'
import baseToast, { Toast, useToaster } from 'react-hot-toast'
import { useHistory } from 'react-router-dom'

import { routes } from 'helpers/routes'

import 'animate.css'

export interface TicketNotificationData {
  title: string
  body: string
  ticketId: string
}

export const TicketNotification: React.FC = () => {
  const history = useHistory()
  const { toasts, handlers } = useToaster()
  const { startPause, endPause, calculateOffset, updateHeight } = handlers

  const handleOnClickContent = (
    toast: Toast,
    notification: TicketNotificationData,
  ) => {
    const el = document.getElementById(toast.id)

    el?.classList.remove('animate__fadeInDown')
    el?.classList.add('animate__fadeOutUp')

    if (notification.ticketId) {
      history.push(`${routes.ticket.path}/${notification.ticketId}/detail`)
    }

    baseToast.dismiss(toast.id)
  }

  return (
    <div
      className='ticket-notification'
      onMouseEnter={startPause}
      onMouseLeave={endPause}
    >
      {toasts.map((toast) => {
        const offset = calculateOffset(toast, {
          reverseOrder: false,
          gutter: 8,
        })

        const ref = (el: HTMLDivElement | null) => {
          if (el && typeof toast.height !== 'number') {
            const height = el.getBoundingClientRect().height
            updateHeight(toast.id, height)
          }
        }

        const notification = toast.message as unknown as TicketNotificationData

        return (
          <div
            key={toast.id}
            ref={ref}
            id={toast.id}
            onClick={() => handleOnClickContent(toast, notification)}
            className='ticket-notification__content animate__animated animate__fadeInDown animate__delay-2s'
            style={{
              opacity: toast.visible ? 1 : 0,
              transform: `translateY(${offset}px)`,
            }}
            {...toast.ariaProps}
          >
            <div className='ticket-notification__content__card'>
              <div className='ticket-notification__content__card__image'>
                <img src='/logo192.png' alt='logo' />
              </div>
              <div className='ticket-notification__content__card__text'>
                <div className='ticket-notification__content__card__text__title'>
                  {notification.title}
                </div>
                <span>{notification.body}</span>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
